import { DataBroker } from './DataBroker';


const PRAKIM = [
	{	"name": "תשרי",
		"wide": true,
		"month": 7,
		"prakim":	[	{ key:1,  name:"א תשרי",  path:"7/1" },
						{ key:2,  name:"ב תשרי",  path:"7/2" },
						{ key:3,  name:"ג תשרי",  path:"7/3" },
						{ key:4,  name:"ד תשרי",  path:"7/4" },
						{ key:5,  name:"ה תשרי",  path:"7/5" },
						{ key:6,  name:"ו תשרי",  path:"7/6" },
						{ key:7,  name:"ז תשרי",  path:"7/7" },
						{ key:8,  name:"ח תשרי",  path:"7/8" },
						{ key:9,  name:"ט תשרי",  path:"7/9" },
						{ key:10, name:"י תשרי",  path:"7/10" },
						{ key:11, name:"יא תשרי", path:"7/11" },
						{ key:12, name:"יב תשרי", path:"7/12" },
						{ key:13, name:"יג תשרי", path:"7/13" },
						{ key:14, name:"יד תשרי", path:"7/14" },
						{ key:15, name:"טו תשרי", path:"7/15" },
						{ key:16, name:"טז תשרי", path:"7/16" },
						{ key:17, name:"יז תשרי", path:"7/17" },
						{ key:18, name:"יח תשרי", path:"7/18" },
						{ key:19, name:"יט תשרי", path:"7/19" },
						{ key:20, name:"כ תשרי",  path:"7/20" },
						{ key:21, name:"כא תשרי", path:"7/21" },
						{ key:22, name:"כב תשרי", path:"7/22" },
						{ key:23, name:"כג תשרי", path:"7/23" },
						{ key:24, name:"כד תשרי", path:"7/24" },
						{ key:25, name:"כה תשרי", path:"7/25" },
						{ key:26, name:"כו תשרי", path:"7/26" },
						{ key:27, name:"כז תשרי", path:"7/27" },
						{ key:28, name:"כח תשרי", path:"7/28" },
						{ key:29, name:"כט תשרי", path:"7/29" },
						{ key:30, name:"ל תשרי",  path:"7/30" }
					]
	},
	{	"name": "חשון",
		"wide": true,
		"month": 8,
		"prakim":	[	{ key:31,  name:"א חשון", path:"8/1" },
						{ key:32,  name:"ב חשון", path:"8/2" },
						{ key:33,  name:"ג חשון", path:"8/3" },
						{ key:34,  name:"ד חשון", path:"8/4" },
						{ key:35,  name:"ה חשון", path:"8/5" },
						{ key:36,  name:"ו חשון", path:"8/6" },
						{ key:37,  name:"ז חשון", path:"8/7" },
						{ key:38,  name:"ח חשון", path:"8/8" },
						{ key:39,  name:"ט חשון", path:"8/9" },
						{ key:40, name:"י חשון",  path:"8/10" },
						{ key:41, name:"יא חשון", path:"8/11" },
						{ key:42, name:"יב חשון", path:"8/12" },
						{ key:43, name:"יג חשון", path:"8/13" },
						{ key:44, name:"יד חשון", path:"8/14" },
						{ key:45, name:"טו חשון", path:"8/15" },
						{ key:46, name:"טז חשון", path:"8/16" },
						{ key:47, name:"יז חשון", path:"8/17" },
						{ key:48, name:"יח חשון", path:"8/18" },
						{ key:49, name:"יט חשון", path:"8/19" },
						{ key:50, name:"כ חשון",  path:"8/20" },
						{ key:51, name:"כא חשון", path:"8/21" },
						{ key:52, name:"כב חשון", path:"8/22" },
						{ key:53, name:"כג חשון", path:"8/23" },
						{ key:54, name:"כד חשון", path:"8/24" },
						{ key:55, name:"כה חשון", path:"8/25" },
						{ key:56, name:"כו חשון", path:"8/26" },
						{ key:57, name:"כז חשון", path:"8/27" },
						{ key:58, name:"כח חשון", path:"8/28" },
						{ key:59, name:"כט חשון", path:"8/29" }
					]
	},
	{	"name": "כסלו",
		"wide": true,
		"month": 9,
		"prakim":	[	{ key:60, name:"א כסלו",  path:"9/1" },
						{ key:61, name:"ב כסלו",  path:"9/2" },
						{ key:62, name:"ג כסלו",  path:"9/3" },
						{ key:63, name:"ד כסלו",  path:"9/4" },
						{ key:64, name:"ה כסלו",  path:"9/5" },
						{ key:65, name:"ו כסלו",  path:"9/6" },
						{ key:66, name:"ז כסלו",  path:"9/7" },
						{ key:67, name:"ח כסלו",  path:"9/8" },
						{ key:68, name:"ט כסלו",  path:"9/9" },
						{ key:69, name:"י כסלו",  path:"9/10" },
						{ key:70, name:"יא כסלו", path:"9/11" },
						{ key:71, name:"יב כסלו", path:"9/12" },
						{ key:72, name:"יג כסלו", path:"9/13" },
						{ key:73, name:"יד כסלו", path:"9/14" },
						{ key:74, name:"טו כסלו", path:"9/15" },
						{ key:75, name:"טז כסלו", path:"9/16" },
						{ key:76, name:"יז כסלו", path:"9/17" },
						{ key:77, name:"יח כסלו", path:"9/18" },
						{ key:78, name:"יט כסלו", path:"9/19" },
						{ key:79, name:"כ כסלו",  path:"9/20" },
						{ key:80, name:"כא כסלו", path:"9/21" },
						{ key:81, name:"כב כסלו", path:"9/22" },
						{ key:82, name:"כג כסלו", path:"9/23" },
						{ key:83, name:"כד כסלו", path:"9/24" },
						{ key:84, name:"כה כסלו", path:"9/25" },
						{ key:85, name:"כו כסלו", path:"9/26" },
						{ key:86, name:"כז כסלו", path:"9/27" },
						{ key:87, name:"כח כסלו", path:"9/28" },
						{ key:88, name:"כט כסלו", path:"9/29" }
					]
	},
	{	"name": "טבת",
		"wide": true,
		"month": 10,
		"prakim":	[	{ key:89,  name:"א טבת",  path:"10/1" },
						{ key:90,  name:"ב טבת",  path:"10/2" },
						{ key:91,  name:"ג טבת",  path:"10/3" },
						{ key:92,  name:"ד טבת",  path:"10/4" },
						{ key:93,  name:"ה טבת",  path:"10/5" },
						{ key:94,  name:"ו טבת",  path:"10/6" },
						{ key:95,  name:"ז טבת",  path:"10/7" },
						{ key:96,  name:"ח טבת",  path:"10/8" },
						{ key:97,  name:"ט טבת",  path:"10/9" },
						{ key:98,  name:"י טבת",  path:"10/10" },
						{ key:99,  name:"יא טבת", path:"10/11" },
						{ key:100, name:"יב טבת", path:"10/12" },
						{ key:101, name:"יג טבת", path:"10/13" },
						{ key:102, name:"יד טבת", path:"10/14" },
						{ key:103, name:"טו טבת", path:"10/15" },
						{ key:104, name:"טז טבת", path:"10/16" },
						{ key:105, name:"יז טבת", path:"10/17" },
						{ key:106, name:"יח טבת", path:"10/18" },
						{ key:107, name:"יט טבת", path:"10/19" },
						{ key:108, name:"כ טבת",  path:"10/20" },
						{ key:109, name:"כא טבת", path:"10/21" },
						{ key:110, name:"כב טבת", path:"10/22" },
						{ key:111, name:"כג טבת", path:"10/23" },
						{ key:112, name:"כד טבת", path:"10/24" },
						{ key:113, name:"כה טבת", path:"10/25" },
						{ key:114, name:"כו טבת", path:"10/26" },
						{ key:115, name:"כז טבת", path:"10/27" },
						{ key:116, name:"כח טבת", path:"10/28" },
						{ key:117, name:"כט טבת", path:"10/29" }
					]
	},
	{	"name": "שבט",
		"wide": true,
		"month": 11,
		"prakim":	[	{ key:118, name:"א שבט",  path:"11/1" },
						{ key:119, name:"ב שבט",  path:"11/2" },
						{ key:120, name:"ג שבט",  path:"11/3" },
						{ key:121, name:"ד שבט",  path:"11/4" },
						{ key:122, name:"ה שבט",  path:"11/5" },
						{ key:123, name:"ו שבט",  path:"11/6" },
						{ key:124, name:"ז שבט",  path:"11/7" },
						{ key:125, name:"ח שבט",  path:"11/8" },
						{ key:126, name:"ט שבט",  path:"11/9" },
						{ key:127, name:"י שבט",  path:"11/10" },
						{ key:128, name:"יא שבט", path:"11/11" },
						{ key:129, name:"יב שבט", path:"11/12" },
						{ key:130, name:"יג שבט", path:"11/13" },
						{ key:131, name:"יד שבט", path:"11/14" },
						{ key:132, name:"טו שבט", path:"11/15" },
						{ key:133, name:"טז שבט", path:"11/16" },
						{ key:134, name:"יז שבט", path:"11/17" },
						{ key:135, name:"יח שבט", path:"11/18" },
						{ key:136, name:"יט שבט", path:"11/19" },
						{ key:137, name:"כ שבט",  path:"11/20" },
						{ key:138, name:"כא שבט", path:"11/21" },
						{ key:139, name:"כב שבט", path:"11/22" },
						{ key:140, name:"כג שבט", path:"11/23" },
						{ key:141, name:"כד שבט", path:"11/24" },
						{ key:142, name:"כה שבט", path:"11/25" },
						{ key:143, name:"כו שבט", path:"11/26" },
						{ key:144, name:"כז שבט", path:"11/27" },
						{ key:145, name:"כח שבט", path:"11/28" },
						{ key:146, name:"כט שבט", path:"11/29" },
						{ key:147, name:"ל שבט",  path:"11/30" }
					]
	},
	{	"name": "אדר א",
		"wide": true,
		"month": 12,
		"prakim":	[	{ key:148, name:"א אדר א",  path:"12/1" },
						{ key:149, name:"ב אדר א",  path:"12/2" },
						{ key:150, name:"ג אדר א",  path:"12/3" },
						{ key:151, name:"ד אדר א",  path:"12/4" },
						{ key:152, name:"ה אדר א",  path:"12/5" },
						{ key:153, name:"ו אדר א",  path:"12/6" },
						{ key:154, name:"ז אדר א",  path:"12/7" },
						{ key:155, name:"ח אדר א",  path:"12/8" },
						{ key:156, name:"ט אדר א",  path:"12/9" },
						{ key:157, name:"י אדר א",  path:"12/10" },
						{ key:158, name:"יא אדר א", path:"12/11" },
						{ key:159, name:"יב אדר א", path:"12/12" },
						{ key:160, name:"יג אדר א", path:"12/13" },
						{ key:161, name:"יד אדר א", path:"12/14" },
						{ key:162, name:"טו אדר א", path:"12/15" },
						{ key:163, name:"טז אדר א", path:"12/16" },
						{ key:164, name:"יז אדר א", path:"12/17" },
						{ key:165, name:"יח אדר א", path:"12/18" },
						{ key:166, name:"יט אדר א", path:"12/19" },
						{ key:167, name:"כ אדר א",  path:"12/20" },
						{ key:168, name:"כא אדר א", path:"12/21" },
						{ key:169, name:"כב אדר א", path:"12/22" },
						{ key:170, name:"כג אדר א", path:"12/23" },
						{ key:171, name:"כד אדר א", path:"12/24" },
						{ key:172, name:"כה אדר א", path:"12/25" },
						{ key:173, name:"כו אדר א", path:"12/26" },
						{ key:174, name:"כז אדר א", path:"12/27" },
						{ key:175, name:"כח אדר א", path:"12/28" },
						{ key:176, name:"כט אדר א", path:"12/29" },
						{ key:177, name:"ל אדר א",  path:"12/30" }
					]
	},
	{	"name": "אדר ב",
		"wide": true,
		"month": 13,
		"prakim":	[	{ key:178, name:"א אדר ב",  path:"13/1" },
						{ key:179, name:"ב אדר ב",  path:"13/2" },
						{ key:180, name:"ג אדר ב",  path:"13/3" },
						{ key:181, name:"ד אדר ב",  path:"13/4" },
						{ key:182, name:"ה אדר ב",  path:"13/5" },
						{ key:183, name:"ו אדר ב",  path:"13/6" },
						{ key:184, name:"ז אדר ב",  path:"13/7" },
						{ key:185, name:"ח אדר ב",  path:"13/8" },
						{ key:186, name:"ט אדר ב",  path:"13/9" },
						{ key:187, name:"י אדר ב",  path:"13/10" },
						{ key:188, name:"יא אדר ב", path:"13/11" },
						{ key:189, name:"יב אדר ב", path:"13/12" },
						{ key:190, name:"יג אדר ב", path:"13/13" },
						{ key:191, name:"יד אדר ב", path:"13/14" },
						{ key:192, name:"טו אדר ב", path:"13/15" },
						{ key:193, name:"טז אדר ב", path:"13/16" },
						{ key:194, name:"יז אדר ב", path:"13/17" },
						{ key:195, name:"יח אדר ב", path:"13/18" },
						{ key:196, name:"יט אדר ב", path:"13/19" },
						{ key:197, name:"כ אדר ב",  path:"13/20" },
						{ key:198, name:"כא אדר ב", path:"13/21" },
						{ key:199, name:"כב אדר ב", path:"13/22" },
						{ key:200, name:"כג אדר ב", path:"13/23" },
						{ key:201, name:"כד אדר ב", path:"13/24" },
						{ key:202, name:"כה אדר ב", path:"13/25" },
						{ key:203, name:"כו אדר ב", path:"13/26" },
						{ key:204, name:"כז אדר ב", path:"13/27" },
						{ key:205, name:"כח אדר ב", path:"13/28" },
						{ key:206, name:"כט אדר ב", path:"13/29" }
					]
	},
	{	"name": "ניסן",
		"wide": true,
		"month": 1,
		"prakim":	[	{ key:207, name:"א ניסן",  path:"1/1" },
						{ key:208, name:"ב ניסן",  path:"1/2" },
						{ key:209, name:"ג ניסן",  path:"1/3" },
						{ key:210, name:"ד ניסן",  path:"1/4" },
						{ key:211, name:"ה ניסן",  path:"1/5" },
						{ key:212, name:"ו ניסן",  path:"1/6" },
						{ key:213, name:"ז ניסן",  path:"1/7" },
						{ key:214, name:"ח ניסן",  path:"1/8" },
						{ key:215, name:"ט ניסן",  path:"1/9" },
						{ key:216, name:"י ניסן",  path:"1/10" },
						{ key:217, name:"יא ניסן", path:"1/11" },
						{ key:218, name:"יב ניסן", path:"1/12" },
						{ key:219, name:"יג ניסן", path:"1/13" },
						{ key:220, name:"יד ניסן", path:"1/14" },
						{ key:221, name:"טו ניסן", path:"1/15" },
						{ key:222, name:"טז ניסן", path:"1/16" },
						{ key:223, name:"יז ניסן", path:"1/17" },
						{ key:224, name:"יח ניסן", path:"1/18" },
						{ key:225, name:"יט ניסן", path:"1/19" },
						{ key:226, name:"כ ניסן",  path:"1/20" },
						{ key:227, name:"כא ניסן", path:"1/21" },
						{ key:228, name:"כב ניסן", path:"1/22" },
						{ key:229, name:"כג ניסן", path:"1/23" },
						{ key:230, name:"כד ניסן", path:"1/24" },
						{ key:231, name:"כה ניסן", path:"1/25" },
						{ key:232, name:"כו ניסן", path:"1/26" },
						{ key:233, name:"כז ניסן", path:"1/27" },
						{ key:234, name:"כח ניסן", path:"1/28" },
						{ key:235, name:"כט ניסן", path:"1/29" },
						{ key:236, name:"ל ניסן",  path:"1/30" }
					]
	},
	{	"name": "אייר",
		"wide": true,
		"month": 2,
		"prakim":	[	{ key:237, name:"א אייר",  path:"2/1" },
						{ key:238, name:"ב אייר",  path:"2/2" },
						{ key:239, name:"ג אייר",  path:"2/3" },
						{ key:240, name:"ד אייר",  path:"2/4" },
						{ key:241, name:"ה אייר",  path:"2/5" },
						{ key:242, name:"ו אייר",  path:"2/6" },
						{ key:243, name:"ז אייר",  path:"2/7" },
						{ key:244, name:"ח אייר",  path:"2/8" },
						{ key:245, name:"ט אייר",  path:"2/9" },
						{ key:246, name:"י אייר",  path:"2/10" },
						{ key:247, name:"יא אייר", path:"2/11" },
						{ key:248, name:"יב אייר", path:"2/12" },
						{ key:249, name:"יג אייר", path:"2/13" },
						{ key:250, name:"יד אייר", path:"2/14" },
						{ key:251, name:"טו אייר", path:"2/15" },
						{ key:252, name:"טז אייר", path:"2/16" },
						{ key:253, name:"יז אייר", path:"2/17" },
						{ key:254, name:"יח אייר", path:"2/18" },
						{ key:255, name:"יט אייר", path:"2/19" },
						{ key:256, name:"כ אייר",  path:"2/20" },
						{ key:257, name:"כא אייר", path:"2/21" },
						{ key:258, name:"כב אייר", path:"2/22" },
						{ key:259, name:"כג אייר", path:"2/23" },
						{ key:260, name:"כד אייר", path:"2/24" },
						{ key:261, name:"כה אייר", path:"2/25" },
						{ key:262, name:"כו אייר", path:"2/26" },
						{ key:263, name:"כז אייר", path:"2/27" },
						{ key:264, name:"כח אייר", path:"2/28" },
						{ key:265, name:"כט אייר", path:"2/29" }
					]
	},
	{	"name": "סיון",
		"wide": true,
		"month": 3,
		"prakim":	[	{ key:266, name:"א סיון",  path:"3/1" },
						{ key:267, name:"ב סיון",  path:"3/2" },
						{ key:268, name:"ג סיון",  path:"3/3" },
						{ key:269, name:"ד סיון",  path:"3/4" },
						{ key:270, name:"ה סיון",  path:"3/5" },
						{ key:271, name:"ו סיון",  path:"3/6" },
						{ key:272, name:"ז סיון",  path:"3/7" },
						{ key:273, name:"ח סיון",  path:"3/8" },
						{ key:274, name:"ט סיון",  path:"3/9" },
						{ key:275, name:"י סיון",  path:"3/10" },
						{ key:276, name:"יא סיון", path:"3/11" },
						{ key:277, name:"יב סיון", path:"3/12" },
						{ key:278, name:"יג סיון", path:"3/13" },
						{ key:279, name:"יד סיון", path:"3/14" },
						{ key:280, name:"טו סיון", path:"3/15" },
						{ key:281, name:"טז סיון", path:"3/16" },
						{ key:282, name:"יז סיון", path:"3/17" },
						{ key:283, name:"יח סיון", path:"3/18" },
						{ key:284, name:"יט סיון", path:"3/19" },
						{ key:285, name:"כ סיון",  path:"3/20" },
						{ key:286, name:"כא סיון", path:"3/21" },
						{ key:287, name:"כב סיון", path:"3/22" },
						{ key:288, name:"כג סיון", path:"3/23" },
						{ key:289, name:"כד סיון", path:"3/24" },
						{ key:290, name:"כה סיון", path:"3/25" },
						{ key:291, name:"כו סיון", path:"3/26" },
						{ key:292, name:"כז סיון", path:"3/27" },
						{ key:293, name:"כח סיון", path:"3/28" },
						{ key:294, name:"כט סיון", path:"3/29" },
						{ key:295, name:"ל סיון",  path:"3/30" }
					]
	},
	{	"name": "תמוז",
		"wide": true,
		"month": 4,
		"prakim":	[	{ key:296, name:"א תמוז",  path:"4/1" },
						{ key:297, name:"ב תמוז",  path:"4/2" },
						{ key:298, name:"ג תמוז",  path:"4/3" },
						{ key:299, name:"ד תמוז",  path:"4/4" },
						{ key:300, name:"ה תמוז",  path:"4/5" },
						{ key:301, name:"ו תמוז",  path:"4/6" },
						{ key:302, name:"ז תמוז",  path:"4/7" },
						{ key:303, name:"ח תמוז",  path:"4/8" },
						{ key:304, name:"ט תמוז",  path:"4/9" },
						{ key:305, name:"י תמוז",  path:"4/10" },
						{ key:306, name:"יא תמוז", path:"4/11" },
						{ key:307, name:"יב תמוז", path:"4/12" },
						{ key:308, name:"יג תמוז", path:"4/13" },
						{ key:309, name:"יד תמוז", path:"4/14" },
						{ key:310, name:"טו תמוז", path:"4/15" },
						{ key:311, name:"טז תמוז", path:"4/16" },
						{ key:312, name:"יז תמוז", path:"4/17" },
						{ key:313, name:"יח תמוז", path:"4/18" },
						{ key:314, name:"יט תמוז", path:"4/19" },
						{ key:315, name:"כ תמוז",  path:"4/20" },
						{ key:316, name:"כא תמוז", path:"4/21" },
						{ key:317, name:"כב תמוז", path:"4/22" },
						{ key:318, name:"כג תמוז", path:"4/23" },
						{ key:319, name:"כד תמוז", path:"4/24" },
						{ key:320, name:"כה תמוז", path:"4/25" },
						{ key:321, name:"כו תמוז", path:"4/26" },
						{ key:322, name:"כז תמוז", path:"4/27" },
						{ key:323, name:"כח תמוז", path:"4/28" },
						{ key:324, name:"כט תמוז", path:"4/29" }
					]
	},
	{	"name": "מנחם אב",
		"wide": true,
		"month": 5,
		"prakim":	[	{ key:325, name:"א מנחם אב",  path:"5/1" },
						{ key:326, name:"ב מנחם אב",  path:"5/2" },
						{ key:327, name:"ג מנחם אב",  path:"5/3" },
						{ key:328, name:"ד מנחם אב",  path:"5/4" },
						{ key:329, name:"ה מנחם אב",  path:"5/5" },
						{ key:330, name:"ו מנחם אב",  path:"5/6" },
						{ key:331, name:"ז מנחם אב",  path:"5/7" },
						{ key:332, name:"ח מנחם אב",  path:"5/8" },
						{ key:333, name:"ט מנחם אב",  path:"5/9" },
						{ key:334, name:"י מנחם אב",  path:"5/10" },
						{ key:335, name:"יא מנחם אב", path:"5/11" },
						{ key:336, name:"יב מנחם אב", path:"5/12" },
						{ key:337, name:"יג מנחם אב", path:"5/13" },
						{ key:338, name:"יד מנחם אב", path:"5/14" },
						{ key:339, name:"טו מנחם אב", path:"5/15" },
						{ key:340, name:"טז מנחם אב", path:"5/16" },
						{ key:341, name:"יז מנחם אב", path:"5/17" },
						{ key:342, name:"יח מנחם אב", path:"5/18" },
						{ key:343, name:"יט מנחם אב", path:"5/19" },
						{ key:344, name:"כ מנחם אב",  path:"5/20" },
						{ key:345, name:"כא מנחם אב", path:"5/21" },
						{ key:346, name:"כב מנחם אב", path:"5/22" },
						{ key:347, name:"כג מנחם אב", path:"5/23" },
						{ key:348, name:"כד מנחם אב", path:"5/24" },
						{ key:349, name:"כה מנחם אב", path:"5/25" },
						{ key:350, name:"כו מנחם אב", path:"5/26" },
						{ key:351, name:"כז מנחם אב", path:"5/27" },
						{ key:352, name:"כח מנחם אב", path:"5/28" },
						{ key:353, name:"כט מנחם אב", path:"5/29" },
						{ key:354, name:"ל מנחם אב",  path:"5/30" }
					]
	},
	{	"name": "אלול",
		"wide": true,
		"month": 6,
		"prakim":	[	{ key:355, name:"א אלול",  path:"6/1" },
						{ key:356, name:"ב אלול",  path:"6/2" },
						{ key:357, name:"ג אלול",  path:"6/3" },
						{ key:358, name:"ד אלול",  path:"6/4" },
						{ key:359, name:"ה אלול",  path:"6/5" },
						{ key:360, name:"ו אלול",  path:"6/6" },
						{ key:361, name:"ז אלול",  path:"6/7" },
						{ key:362, name:"ח אלול",  path:"6/8" },
						{ key:363, name:"ט אלול",  path:"6/9" },
						{ key:364, name:"י אלול",  path:"6/10" },
						{ key:365, name:"יא אלול", path:"6/11" },
						{ key:366, name:"יב אלול", path:"6/12" },
						{ key:367, name:"יג אלול", path:"6/13" },
						{ key:368, name:"יד אלול", path:"6/14" },
						{ key:369, name:"טו אלול", path:"6/15" },
						{ key:370, name:"טז אלול", path:"6/16" },
						{ key:371, name:"יז אלול", path:"6/17" },
						{ key:372, name:"יח אלול", path:"6/18" },
						{ key:373, name:"יט אלול", path:"6/19" },
						{ key:374, name:"כ אלול",  path:"6/20" },
						{ key:375, name:"כא אלול", path:"6/21" },
						{ key:376, name:"כב אלול", path:"6/22" },
						{ key:377, name:"כג אלול", path:"6/23" },
						{ key:378, name:"כד אלול", path:"6/24" },
						{ key:379, name:"כה אלול", path:"6/25" },
						{ key:380, name:"כו אלול", path:"6/26" },
						{ key:381, name:"כז אלול", path:"6/27" },
						{ key:382, name:"כח אלול", path:"6/28" },
						{ key:383, name:"כט אלול", path:"6/29" }
					]
	},
];




function GetPerekPath(perekId) {
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);
	return perek.path;
};

function RenderShiur(data) {
	return <div className='HayomYom' dangerouslySetInnerHTML={{ __html: data }} />;
};


export function GetPerekHeaderHY(perekId) {
	const sefer = PRAKIM.find(m => m.prakim.find(p => p.key == perekId));
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);
	return (sefer.title && (perek.hidePerek===undefined||perek.hidePerek) ? sefer.title+" " : "") + perek.name;
};

export function GetPerekNextHY(perekId) {
	if (perekId == 383)
		return 1;

	return ++perekId;
};
export function GetPerekPrevHY(perekId) {
	if (perekId == 1) 
		return 383;

	return --perekId;
};



export async function GetPerekHY(perekId) {
	const perekPath = GetPerekPath(perekId);

	let data = await DataBroker.getDataText('hy/' + perekPath);

	return new Promise((myResolve, myReject) => {
		if (data === null)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(data));
	});
};

export function GetMenuHY() {
	return PRAKIM;
}